import React from 'react';
import { getTrans } from '@/utils/tools';
import { Copywriting } from '@/utils/constants';
import './index.scss';

interface AgentLeaveProps {
  name: string;
}

export default class AgentLeave extends React.Component<AgentLeaveProps> {
  render() {
    const { name } = this.props;

    return (
      <div className="agent-leave">{`${name} ${getTrans(Copywriting.AGENT_LEAVE_TIPS)}`}</div>
    );
  }
}
